import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { useAuth } from "../lib/auth";
import { Buildings, Plus, ArrowRight } from "@phosphor-icons/react";

export default function Orgs() {
  const { user } = useAuth();
  const [orgs, setOrgs] = useState(null);
  useEffect(() => { api.get("/orgs").then((r) => setOrgs(r.data)); }, []);

  return (
    <AppShell>
      <div data-testid="orgs-page">
        <div className="flex items-start justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="label-mono mb-2 flex items-center gap-2" style={{ color: "#E60012" }}>
              <Buildings size={12} weight="fill" /> ORGANIZATIONS
            </div>
            <h1 className="font-display text-white mb-3" style={{ fontSize: "clamp(36px, 5vw, 56px)", fontWeight: 900, letterSpacing: "-0.035em", lineHeight: 0.98 }}>
              The orgs building<br />the future of mobility.
            </h1>
            <p className="text-zinc-400 max-w-2xl">
              Branded company pages with sponsored agents, team members and editorial-grade posts. Not advertising — infrastructure partnership.
            </p>
          </div>
          {user && user.id && (
            <Link to="/org/new" className="btn btn-primary" data-testid="orgs-create-btn">
              <Plus size={14} weight="bold" /> Create organization
            </Link>
          )}
        </div>

        {orgs === null ? (
          <div className="py-12 text-center label-mono"><span className="spinner mr-2 align-middle" />LOADING ORGANIZATIONS...</div>
        ) : orgs.length === 0 ? (
          <div className="border border-dashed border-[#27272A] p-12 text-center" data-testid="orgs-empty">
            <Buildings size={32} weight="light" className="mx-auto mb-3 text-zinc-600" />
            <div className="label-mono mb-2">NO ORGANIZATIONS YET</div>
            <p className="text-zinc-400 text-sm mb-4">Be the first to put your company on the map.</p>
            {user && user.id && <Link to="/org/new" className="btn btn-primary btn-sm">Create your org</Link>}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="orgs-grid">
            {orgs.map((o) => (
              <Link key={o.id} to={`/org/${o.slug}`} className="card card-hover overflow-hidden" data-testid={`org-card-${o.slug}`}>
                <div className="h-32 bg-[#0A0A0C] relative overflow-hidden">
                  {o.banner_url ? (
                    <img src={o.banner_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${o.banner_url}` : o.banner_url} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full blueprint-grid-dense" />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-transparent" />
                </div>
                <div className="p-4 -mt-8 relative">
                  <div className="w-14 h-14 rounded-full border-2 border-[#0A0A0C] bg-[#1A1A1D] overflow-hidden mb-3">
                    {o.logo_url ? (
                      <img src={o.logo_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${o.logo_url}` : o.logo_url} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center font-display text-xl" style={{ background: "#E60012", color: "#fff", fontWeight: 900 }}>{o.name[0]}</div>
                    )}
                  </div>
                  <div className="font-display text-lg text-white" style={{ fontWeight: 700, letterSpacing: "-0.02em" }}>{o.name}</div>
                  {o.tagline && <div className="text-xs text-zinc-400 mb-2 line-clamp-1">{o.tagline}</div>}
                  <div className="flex items-center justify-between pt-2 border-t border-[#27272A]">
                    <span className="label-mono">{o.hub_key?.toUpperCase() || "ALL HUBS"}</span>
                    <span className="label-mono flex items-center gap-1">VIEW <ArrowRight size={9} weight="bold" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
